import jsonp from 'jsonp';
import lockr from 'lockr';

export function storeInternalIp() {
  jsonp(
    'https://internal.devtools.jiemo.net',
    { param: 'jsoncallback', timeout: 10000 },
    (e, { ip }) => {
      lockr.set('internal_ip', ip);
    },
  );
}

export function test() {
  return 'test';
}
